// Budget Unique

export var MixinBudget = {
  data: () => ({
    B_BudgetLoaded: false,
    O_Budget: {},
    L_BudgetID: 0,
    R_BudgetModifier: 0,
    R_BudgetTotal: 0,
    R_BudgetRemaining: 0,
    L_BudgetEngageExclude: 0,
    L_BudgetEngageNumber: 0,
    TO_BudgetEngagements: []
  }),
  computed: {
    B_BudgetOut: function() {
      return this.R_BudgetRemaining < 0;
    }
  },
  methods: {
    Fct_BudgetLoad(L_BudgetID, B_ForceUpdate = false) {
      if (!this.B_BudgetLoaded || B_ForceUpdate) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/" + L_BudgetID + "/", { headers: { Authorization: T_Token } })
          .then(O_Response => {
            this.O_Budget = {};
            if (O_Response.data != "") {
              this.O_Budget = O_Response.data;
            }
            this.Fct_BudgetLaunch();
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        return Promise.resolve();
      }
    },
    Fct_BudgetReLoad(L_BudgetID) {
      this.B_BudgetLoaded = false;
      this.Fct_BudgetLoad(L_BudgetID);
    },
    Fct_BudgetLaunch() {
      this.B_BudgetLoaded = true;
      this.Fct_BudgetCompute();
    },
    Fct_BudgetCompute() {
      this.R_BudgetRemaining = 0;
      if (this.B_BudgetLoaded) {
        this.L_BudgetID = this.O_Budget.id;
        this.R_BudgetTotal = this.O_Budget.montant;
        this.R_BudgetRemaining = this.O_Budget.montant;

        var engMontant = 0;
        var engConsomme = 0;
        var budgetConsomme = 0;

        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        this.$BackEndAPI
          .get("engagements/budget/" + this.L_BudgetID, { headers: { Authorization: T_Token } })
          .then(O_Response => {
            if (O_Response.data != "") {
              var TO_EngagementsList = O_Response.data;
              this.L_BudgetEngageNumber = TO_EngagementsList.length;
              for (var L_Index = 0; L_Index < TO_EngagementsList.length; L_Index++) {
                var O_Engagement = TO_EngagementsList[L_Index];
                if (O_Engagement.fk_Statut != 4) {
                  // Pas refusé
                  //if (O_Engagement.id != this.L_BudgetEngageExclude) {
                  //this.R_BudgetRemaining -= O_Engagement.montant;

                  engConsomme = parseFloat(O_Engagement.totalConsomme);
                  engMontant = parseFloat(O_Engagement.montant);
                  if (engConsomme > engMontant) {
                    budgetConsomme += engConsomme;
                  } else {
                    budgetConsomme += engMontant;
                  }

                  //}
                }
              }
            }

            this.R_BudgetRemaining -= budgetConsomme;
            //this.R_BudgetRemaining -= this.R_BudgetModifier;
            this.R_BudgetRemaining = parseFloat(this.R_BudgetRemaining).toFixed(2);
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      }
    },
    Fct_BudgetEngageList() {
      // A partir du Budget chargé, charge la liste des Engagements liés
      if (this.B_BudgetLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        this.$BackEndAPI
          .get("engagements/budget/" + this.L_BudgetID, { headers: { Authorization: T_Token } })
          .then(O_Response => {
            this.TO_BudgetEngagements = [];
            if (O_Response.data != "") {
              this.TO_BudgetEngagements = O_Response.data;
              for (var L_Index = 0; L_Index < this.TO_BudgetEngagements.length; L_Index++) {
                this.TO_BudgetEngagements[L_Index].dateLivraison = this.IsisFct_Date2Display(this.TO_BudgetEngagements[L_Index].dateLivraison);
              }
            }
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      }
    },
    Fct_BudgetsEngageList(budget_ids) {
      var data = { budget_ids: budget_ids };
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .post("engagements/budgets/", data, { headers: { Authorization: T_Token } })
        .then(O_Response => {
          this.TO_BudgetEngagements = [];
          if (O_Response.data != "") {
            this.TO_BudgetEngagements = O_Response.data;
            for (var L_Index = 0; L_Index < this.TO_BudgetEngagements.length; L_Index++) {
              this.TO_BudgetEngagements[L_Index].dateLivraison = this.IsisFct_Date2Display(this.TO_BudgetEngagements[L_Index].dateLivraison);
            }
          }
        })
        .catch(() => {
          this.$router.push({ name: "Disconnect" });
        });
    }
  }
};
